import React from "react";

import { PageHeader, Descriptions, Divider, Popconfirm, Button, Statistic } from "antd";
import { CheckOutlined, RollbackOutlined } from "@ant-design/icons";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import StatisticAmount from "../../../../../core/components/widget/amountInline/statistic";

import PaymentButton from "../../../../../components/payment/form/button";
import {
    INVOICE_STATUS_IN_REVIEW,
    INVOICE_STATUS_ACCEPTED,
    INVOICE_STATUS_PAID,
} from "../../../../../components/invoice/status/const";

import PaymentList from "./payments";
import AttachmentHeader from "./attachment";
import DetailsHeader from "./details";

const Content = ({ children, extra }) => {
    return (
        <div className="content">
            {/*<img src="https://icon-library.com/images/translate-icon-png/translate-icon-png-9.jpg" alt="content" width="100px"/>*/}
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );
};

const extraContent = (props) => (
    <div
        style={{
            display: "flex",
            width: "max-content",
            justifyContent: "flex-end",
        }}
    >
        <Statistic
            title="Status"
            value={props.data.invoice.status}
            style={{ marginRight: 32 }}
            valueStyle={{ color: '"#7e807f' }}
        />

        <StatisticAmount
            title="Amount"
            value={props.data.invoice.amount_value}
            prefix={props.data.invoice.amount_type}
        />
    </div>
);

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
    }
    _goBack = () => {
        this.props.history.goBack();
    };

    render() {
        const {
            data,
            actionLoading,

            revertInvoice,
            confirmInvoice,
            downloadInvoice,
        } = this.props;

        const onDeletePayment = (id) => this.props.deletePayment(data.invoice.id, id);
        const addPayment = (form) => this.props.addPayment(data.invoice.id, form);

        const actions = (props) => {
            if (data.invoice.status === INVOICE_STATUS_IN_REVIEW) {
                return [
                    <Button
                        key="accept"
                        type="primary"
                        size="small"
                        disabled={actionLoading}
                        onClick={() => confirmInvoice(data.invoice.id)}
                    >
                        <CheckOutlined />
                        <Divider type="vertical" />
                        Mark as accepted
                    </Button>,
                ];
            }

            if (data.invoice.status === INVOICE_STATUS_ACCEPTED) {
                return [
                    <Button
                        key="revert"
                        size="small"
                        icon={<RollbackOutlined />}
                        onClick={() => revertInvoice(data.invoice.id)}
                    >
                        Revert
                    </Button>,
                    <PaymentButton
                        key="payment"
                        buttonLabel="Add payment"
                        onUpload={addPayment}
                        amountValue={props.data.invoice.amount_value}
                        amountType={props.data.invoice.amount_type}
                        defaultText={`Generated from ${data.invoice.display_id}`}
                        fileRequired={false}
                    />,
                ];
            }

            return [];
        };

        return (
            <>
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader
                        ghost={false}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={`${data.invoice.display_id} / ${data.invoice.code}`}
                        subTitle="Invoice"
                        extra={actions(this.props)}
                    >
                        <Content extra={extraContent(this.props)}>
                            <Descriptions size="medium" column={2}>
                                <Descriptions.Item label="Vendor">{data.invoice?.vendor?.name}</Descriptions.Item>
                                <Descriptions.Item label="Date">
                                    {" "}
                                    {Moment(data.invoice.date).format(DATE_FORMAT)}{" "}
                                </Descriptions.Item>
                                <Descriptions.Item label="Notes"> {data.invoice.notes} </Descriptions.Item>
                            </Descriptions>
                        </Content>
                    </PageHeader>
                </div>
                <br />

                <AttachmentHeader
                    attachment={data.invoice?.attachment}
                    onUpload={(form) => this.props.uploadAttachment(data.invoice.id, form)}
                    onDownload={() => this.props.downloadInvoice(data.invoice?.id, data.invoice?.attachment.name)}
                    onRemove={() => this.props.removeAttachment(data.invoice.id)}
                    allowRemove={data.invoice.status === INVOICE_STATUS_IN_REVIEW}
                    isLoading={this.props.actionLoading}
                />

                <br />
                {(data.payments || []).length > 0 && (
                    <PaymentList
                        payments={data.payments}
                        onDeletePayment={onDeletePayment}
                        onDownloadReceipt={this.props.downloadReceipt}
                        actionLoading={this.props.actionLoading}
                    />
                )}
                <br />

                <DetailsHeader
                    details={data.invoice?.vendor_details || []}
                    isLoading={this.props.loading}
                    vendorName={this.props.vendorName}
                    downloadPurchaseOrder={this.props.downloadPurchaseOrder}
                />
            </>
        );
    }
}
